import { Loader2, Undo2 } from 'lucide-react'

import { Button } from 'components/ui/button'
import { toast } from 'components/ui/toast-store'

/**
 * Undo a plan that ran (MYD-624), offered for 24 hours (MYD-619).
 *
 * Asks first, and says plainly what undo will and will not do: records made
 * are removed only if nobody has changed them since, and an invitation that
 * was sent stays sent. What undo actually did is then shown per step by
 * ExecutionProgress.
 */

export interface UndoButtonProps {
	undoing: boolean
	disabled?: boolean
	/** Why it is disabled, e.g. a read-only session. */
	reason?: string | null
	onUndo: () => void
}

export function UndoButton({ undoing, disabled, reason, onUndo }: UndoButtonProps) {
	const ask = async () => {
		const ok = await toast.confirm({
			title: 'Undo this plan?',
			message:
				"What it created is removed, unless someone has changed it since. Partners it added lose that access. Invitations it sent can't be recalled.",
			confirmLabel: 'Undo',
		})
		if (ok) onUndo()
	}
	return (
		<Button variant="ghost" isOutline onClick={ask} disabled={disabled || undoing} title={reason ?? undefined}>
			{undoing ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Undo2 className="mr-1.5 h-3.5 w-3.5" />}
			{undoing ? 'Undoing…' : 'Undo'}
		</Button>
	)
}

export default UndoButton
